import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { DateRangeCustom } from '../../common/html/input/DateRangeCustom'
import { changeFilter, selectFilter } from '../store/slice'

export const DateDownload = () => {
  const dispatch = useDispatch()

  const fromDate = useSelector(selectFilter('DownLoadDateFrom'))
  const toDate = useSelector(selectFilter('DownLoadDateTo'))

  const onFromChange = (value) => {
    dispatch(changeFilter({ DownLoadDateFrom: value, Page: 1 }))
  }

  const onToChange = (value) => {
    dispatch(changeFilter({ DownLoadDateTo: value, Page: 1 }))
  }

  return (
    <>
      <div>
        <Element
          elementName="p"
          style={{
            color: '#191D25',
            fontWeight: 600,
          }}
        >
          <Translate value="library.downloadedFiles.DELIVERY_DATE" />
        </Element>
        <div className="dFlex gap1">
          <DateRangeCustom
            onFromChange={onFromChange}
            onToChange={onToChange}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>
      </div>
    </>
  )
}
